import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import axios from "axios";
import { formatDiffDates, getCurrentDate } from "../../../Utilitie";

const Head = [
  "S.",
  "HEAD",
  "DATE",
  "WAGONS",
  "TONNES",
  "MT",
  "PUCTUALITY",
  "-",
  "TOTAL",
  "PER DAY",
];
const Head2 = ["RANK", "DATE", "VALUE", "RANK", "DATE", "VALUE"];

const CIPunctualityData = ({ date }) => {
  const urlCrisPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;
  const tableRef = useRef();
  const [Data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlCrisPrefix}get_target_loading_and_punctuality_Total_m_report02?date=${date}`,
      );
      if (response.data.status === "ok") {
        setData(response.data.data);
      } else {
        setData({});
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchedData();
  }, [date]);

  return (
    <div>
      <div
        className="table-responsive pt-2 fw-bold "
        style={{ fontSize: "11px", maxHeight: "750px" }}
      >
        <table
          className="table table-hover table-striped glassTable w-100 text-center"
          ref={tableRef}
        >
          {" "}
          <thead className="sticky-top   ">
            <tr>
              <th className="borderRightWhite"></th>
              <th colSpan={5} className="borderRightWhite">
                TARGET LOADING 2026-27
              </th>
              <th colSpan={2} className="borderRightWhite">
                PUNCTUALITY
              </th>
              <th colSpan={3}>REMAINING TARGET</th>
            </tr>
            <tr>
              {Head.map((col, i) => (
                <th
                  key={i}
                  colSpan={col === "PUCTUALITY" ? 2 : 1}
                  className={
                    col === "S." || col === "MT" || col === "PUCTUALITY"
                      ? "borderRightWhite"
                      : null
                  }
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* /////////////////////////////////////////// */}
            <tr>
              <td className="borderRightWhite">1.</td>
              <td>Y_Day_Ldng</td>
              <td>
                {Data.target_loading?.y_day_trgt_ldgn.map((o) =>
                  o.report_date?.slice(0, 10),
                )}
              </td>
              <td>{Data.target_wagon?.wagon.map((o) => o.value)}</td>
              <td>-</td>
              <td className="borderRightWhite">
                {Data.target_loading?.y_day_trgt_ldgn.map((o) => o.value)}
              </td>
              <td>SPL. TRAIN </td>
              <td className="borderRightWhite">- </td>
              <td>TGT WGN </td>
              <td>657045 </td>
              <td>
                {(
                  Number(657045) /
                  formatDiffDates(
                    Data.current_yr_date?.start,
                    Data.current_yr_date?.end,
                  )
                ).toFixed(1)}
              </td>
            </tr>
            {/* ////////////////////////////////////////////////// */}
            <tr>
              <td className="borderRightWhite">2.</td>
              <td colSpan={2}>Cumulative Loading</td>

              <td>{Data.target_wagon?.cumulative_wagon.map((o) => o.value)}</td>

              <td>-</td>
              <td className="borderRightWhite">
                {Data.target_loading?.cumulative_target_loading.map(
                  (o) => o.value,
                )}
              </td>
              <td>MAIL EX. </td>
              <td className="borderRightWhite">
                {Data.punctuality?.mail_exp.map((o) => o.value)}
              </td>
              <td>PROG. LDNG </td>
              <td>{Data.target_wagon?.cumulative_wagon.map((o) => o.value)}</td>
              <td>
                {(
                  Data.target_wagon?.cumulative_wagon.map((o) => o.value) /
                  formatDiffDates(
                    Data.current_yr_date?.start,
                    Data.current_yr_date?.end,
                  )
                ).toFixed(1)}
              </td>
            </tr>
            {/* ////////////////////////////////////////////////////////////// */}
            <tr>
              <td className="borderRightWhite">3.</td>
              <td>% Done Upto</td>{" "}
              <td>
                {Data.target_loading?.y_day_trgt_ldgn.map((o) =>
                  o.report_date?.slice(0, 10),
                )}
              </td>
              <td>
                {(
                  Data.target_wagon?.cumulative_wagon.map((o) => o.value) /
                  6570.45
                ).toFixed(1)}
                %
              </td>
              <td>-</td>
              <td className="borderRightWhite">
                {(
                  Data.target_loading?.cumulative_target_loading.map(
                    (o) => o.value,
                  ) / 0.44
                ).toFixed(1)}
                %
              </td>
              <td>PASS </td>
              <td className="borderRightWhite">
                {Data.punctuality?.mpso_pass.map((o) => o.value)}
              </td>
              <td>REM. TGT </td>
              <td>
                {" "}
                {647045 -
                  Data.target_wagon?.cumulative_wagon.map((o) => o.value)}
              </td>
              <td>
                {(
                  (647045 -
                    Data.target_wagon?.cumulative_wagon.map((o) => o.value)) /
                  (365 -
                    formatDiffDates(
                      Data.current_yr_date?.start,
                      Data.current_yr_date?.end,
                    ))
                ).toFixed(1)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="m-1">
        <DownloadExcel
          tableRef={tableRef}
          fileName={`ComparativeInterchange`}
        />
      </div>
    </div>
  );
};

export default CIPunctualityData;
